module.exports = __webpack_public_path__ + "static/media/7-3.8f51e39a.mp3";